import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { resetPasswordSubmitFormSchema } from './reset-password-submit-form.schema';

export const useResetPasswordSubmitForm = () => {
  return useForm({
    resolver: yupResolver(resetPasswordSubmitFormSchema),
  });
};
